import Alpine from "alpinejs";

window.Alpine = Alpine;
Alpine.start();
window.addEventListener("DOMContentLoaded", function () {
  // find all elements with .menu-item-has-children and preventDefault on click
  document
    .querySelector(".menu")
    // bind click event to it
    .addEventListener("click", function (event) {
      //get the li where the click was located in
      var li = event.target.closest("li");
      // see if there is a submenu inside of the li
      var submenu = li.querySelector("ul");
      if (submenu) {
        // if there is, stop the event
        event.preventDefault();
        // toggle the class to show and hide the sub menu
        submenu.classList.toggle("active");
        document.querySelectorAll(".menu .active").forEach(function (sub) {
          if (sub !== submenu) {
            sub.classList.remove("active");
          }
        });
      }
    });
});
